/**
 * Shared animation constants for framer-motion
 * Extracted to prevent unnecessary re-renders from inline objects
 */

// Fade in from bottom
export const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

// Fade in from left
export const fadeInLeft = {
  initial: { opacity: 0, x: -20 },
  animate: { opacity: 1, x: 0 }
};

// Fade in from right
export const fadeInRight = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 }
};

// Simple fade
export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 }
};

// Scale up
export const scaleIn = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 }
};

// Viewport animation settings
export const viewportOnce = { once: true };
export const viewportMargin = { once: true, margin: '-50px' };

// Standard transitions
export const transitionFast = { duration: 0.3 };
export const transitionMedium = { duration: 0.5 };
export const transitionSlow = { duration: 0.6 };
export const transitionEase = { duration: 0.5, ease: [0.22, 1, 0.36, 1] };

// Stagger children helper
export const createStaggerDelay = (index, baseDelay = 0.1) => ({
  duration: 0.5,
  delay: index * baseDelay,
  ease: [0.22, 1, 0.36, 1]
});
